'use client';
import Link from 'next/link';
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../../components/breadcrumb';
import type { HeaderProps } from './header.props';
import { Fragment, useMemo } from 'react';
import { useLanguage } from '@bells/core/i18n';
import { baseLocale } from '@bells/i18n/runtime';

export const Breadcrumbs = ({
  title,
  parents,
  currentLanguage,
}: Pick<HeaderProps, 'currentLanguage' | 'title' | 'parents'>) => {
  const { language } = useLanguage();

  const lang = useMemo(() => {
    return currentLanguage ?? language;
  }, [currentLanguage, language]);

  return (
    <nav className='flex min-w-0 items-center' aria-label='breadcrumb'>
      <ol className='flex min-w-0 items-center gap-1.5 whitespace-nowrap text-sm text-muted-foreground sm:gap-2.5'>
        <BreadcrumbItem className='hidden lg:inline-block'>
          <Link
            className='transition-colors hover:text-foreground'
            href={lang == baseLocale ? `/` : `/${lang}`}
            prefetch={false}
          >
            BB Escort
          </Link>
        </BreadcrumbItem>
        <BreadcrumbSeparator className='hidden lg:inline-block' />

        {(parents ?? []).map((df, index) => (
          <Fragment key={`breadcrumb-${index}`}>
            <BreadcrumbItem className='hidden lg:inline-block'>
              <Link
                className='transition-colors hover:text-foreground'
                prefetch={false}
                href={df.url}
              >
                {df.title}
              </Link>
            </BreadcrumbItem>
            <BreadcrumbSeparator className='hidden lg:inline-block' />
          </Fragment>
        ))}

        <BreadcrumbPage className='truncate text-base font-medium lg:text-sm lg:font-normal'>
          {title}
        </BreadcrumbPage>
      </ol>
    </nav>
  );
};
